const actions = {
  requested: ['triage', 'reject', 'correction', 'setAnimal', 'cancel'],
  corrected: ['triage', 'reject', 'correction', 'setAnimal', 'cancel'],
  correction: ['approve', 'reject', 'cancel'],
  screening: ['approve', 'reject', 'setAnimal', 'changeClinic', 'cancel', 'death'],
  forwarded: ['cancel', 'death'],
  hospitalized: ['cancel', 'release', 'death'],
  medicalRelease: ['pullout', 'cancel', 'death'],
  death: [],
  pullout: ['done', 'cancel'],
  caught: ['done'],
  done: [],
}

export const ALLOWED_TO_CHANGE_PRIORITY = [
  'requested',
  'corrected',
  'correction',
  'screening',
  'forwarded',
  'hospitalized',
  'medicalRelease',
  'pullout',
]

export default (status) => actions[status] || []
